import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'


export default (options = { processClick: false }) => (ComposedComponent) =>

  class WrappedComponent extends PureComponent {

    static WrappedComponent = ComposedComponent

    static displayName = `toggleOpen(${ComposedComponent.displayName || ComposedComponent.name})`

    static propTypes = {
      ...(ComposedComponent.propTypes || {}),
      processClick: PropTypes.bool,
      onToggle: PropTypes.func,
    }

    state = {
      isToggleActive: false,
    }

    toggleClose = (event) => {
      const { processClick, onToggle } = this.props

      if (options.processClick || processClick) {
        event.stopPropagation()

        document.removeEventListener('click', this.toggleClose)
      }

      if (typeof onToggle === 'function') {
        onToggle(false)
      }

      this.setState({
        isToggleActive: false,
      })
    }

    toggleOpen = (event) => {
      const { isToggleActive } = this.state
      const { processClick, onToggle } = this.props

      if (isToggleActive) {
        return
      }

      if (options.processClick || processClick) {
        event.stopPropagation()

        document.addEventListener('click', this.toggleClose)
      }

      if (typeof onToggle === 'function') {
        onToggle(true)
      }

      this.setState({
        isToggleActive: true,
      })
    }

    toggle = () => {
      const { isToggleActive } = this.state

      this.setState({
        isToggleActive: !isToggleActive,
      })
    }

    render() {
      const { isToggleActive } = this.state

      return (
        <ComposedComponent
          {...this.props}
          isToggleActive={isToggleActive}
          toggle={this.toggle}
          toggleOpen={this.toggleOpen}
          toggleClose={this.toggleClose}
        />
      )
    }
  }
